export default "__VITE_ASSET__DmevZ$oQ__";